import React from "react";
import "./Footer.css";
import beach from "../../img/beach.png";
import logo from "../../img/hobbestie_logo_nobg.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faTiktok,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-bg-wrapper">
        <img src={beach} alt="Beach" className="footer-bg" />
      </div>

      <div className="footer-content">
        {/* Links Section */}
        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="/faq" rel="noopener noreferrer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/AboutUs" rel="noopener noreferrer">
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@hobbestie.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  support@hobbestie.app
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Social Media</h4>
            <ul>
              <li>
                <a
                  href="https://twitter.com/hobbestie"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faXTwitter}
                    className="social-icon"
                    size="1x"
                  />
                  X
                </a>
              </li>

              <li>
                <a
                  href="https://www.tiktok.com/@hobbestie"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faTiktok}
                    className="social-icon"
                    size="1x"
                  />
                  TikTok
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/hobbestie.app/"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="social-icon"
                    size="1x"
                  />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright and Logo */}
      <div className="footer-bottom">
        <div className="footer-logo-wrapper">
          <img src={logo} alt="Hobbestie Logo" className="footer-logo-big" />
          <span className="footer-brand-text">hobbestie</span>
        </div>
        <p className="footer-rights">
          &copy; {currentYear} Hobbestie - All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
